import axios from 'axios'
import { Toast } from 'vant'
import errorCode from './errorCode'
import { getToken, setToken } from '@/util/token.js'
import { setCookie, isInXhsMP } from "@/util/index";
import _ from 'lodash'

import { getLocalStorage } from '@/util/index.js'
import TimeoutQueue from '@/util/TimeoutQueue.js'

let baseUrl = getLocalStorage('flyConfigBaseURL') || process.env.VUE_APP_ENV_API_HOST
const timeoutQueue = new TimeoutQueue()


// axios配置
axios.defaults.timeout = 10000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.baseURL = baseUrl
axios.defaults.withCredentials = false

axios.interceptors.response.use((resp) => {
  const requestHeaders = resp.config.headers
  const isLoginRequest = requestHeaders ? Boolean(requestHeaders['X-Expose-Headers']) : false
  // 获取到 xStreamId
  if (isLoginRequest && resp.headers && resp.headers['x-stream-id']) {
    const xStreamId = resp.headers['x-stream-id']
    setToken(xStreamId)
  }
  return Promise.resolve(resp.data)
}, async (error) => {
  // 网络异常处理 start
  const res = await timeoutQueue.dealNetWorkError(error)
  if (res.bol) {
    baseUrl = res?.url
    axios.defaults.baseURL = baseUrl
    const resolveData = await timeoutQueue.setRepeatApi(res?.repeatData)
    if (resolveData) return { isResolveData: true, resolveData }
  }
  timeoutQueue.deleteUrlFromList(error)
  // 网络异常处理 end

  if (error && error.response && error.response?.data?.error_code === 401) {
    Toast.clear()
    miniRouterLink()
  }
  if (!error.response?.data) return

  const { error_msg, error_code } = _.get(error, 'response.data', {})


  const message = errorCode[error_code] ? errorCode[error_code] : error_msg
  return Promise.reject({message})
})

// 设置请求头信息
axios.interceptors.request.use(
  requestConfig => {
    // 登录注册接口headers处理
    if (requestConfig.loginRequest) {
      requestConfig.headers
        ? (requestConfig.headers['X-Expose-Headers'] = 'X-Stream-Id, x-stream-id')
        : (requestConfig.headers = { 'X-Expose-Headers': 'X-Stream-Id, x-stream-id' })
    } else if (!requestConfig.disableToken) {
      // 非其他接口，header带 xStreamId
      const xStreamId = getToken()
      xStreamId && (requestConfig.headers['X-Stream-Id'] = xStreamId)
    }
    return requestConfig
  },
  error => {
    return Promise.reject(error)
  }
)

const request = (method, url, data, options) => {
  if (method==='get'||method==='Get'||method==='GET') {
    return axios({ method, url, params: data, ...options })
  } else {
    return axios({ method, url, data, ...options })
  }
}

function isInWechatMP () {
  return Boolean((navigator.userAgent.match(/micromessenger/i) && navigator.userAgent.match(/miniprogram/i)) || window.__wxjs_environment === 'miniprogram');
}
function miniRouterLink () {

  let weixin = isInWechatMP()
  // 判断是否是小程序webview访问
  if (weixin || weixin.length || window.my) {
    let url = `/pagesB/user/loginByPhone/index`
    if (window.my) {
      window.my.navigateTo({ url })
    } else if (window.wx) {
      // window.wx.miniProgram.navigateTo({ url })
      let Fn = window.wx.miniProgram
      // 测试发现，miniProgram时有时没有？ 到底是window.wx 还是window.wx.miniProgram

      if (_.isEmpty(Fn)) {
        return window.wx.navigateTo({ url })
      }

      return window.wx.miniProgram.navigateTo({ url })
    } else if (isInXhsMP) {
      xhs.miniProgram.navigateTo({ url })
    }
  } else {
    setCookie(
      "set_activity_url",
      decodeURIComponent(
        `${window.location.origin}${window.location.pathname}#${this.$route.fullPath}`
      )
    );
    window.location.href = `${process.env.VUE_APP_ENV_WEB_HOST_THIS}/index.html#/welcome?backAcitvity=true`;
  }
}
export default request
